import { InsightsSection } from './InsightsSection';
import { ListReferencesTable } from './listReferencesTable';
import { useAngularListSegmentContext } from '../contexts/AngularListSegmentContext';
import { useListUsageQueryContext } from './contexts/ListUsageQueryContext';
import { InsightType } from '../domain';

export const ListReferenceInsightsSection = () => {
  const { listDetails } = useAngularListSegmentContext();
  const { isLoading } = useListUsageQueryContext();

  if (listDetails?.emailListId === undefined) {
    return null;
  }

  return (
    <InsightsSection type={InsightType.listUsage} isLoading={isLoading}>
      <ListReferencesTable />
    </InsightsSection>
  );
};
